import { Stack, Title, Text, Space } from '@mantine/core';
import { FC } from 'react';

interface PageHeaderProps {
  title?: string;
  message?: string;
  topElement?: React.ReactNode;
  darkMode?: boolean;
  lowMargin?: boolean;
}

export const PageHeader: FC<PageHeaderProps> = ({
  title,
  message,
  topElement,
  darkMode,
  lowMargin,
}) => {
  const style = darkMode
    ? {
        color: 'var(--mantine-color-clinicalWhite-0)',
      }
    : {};

  return (
    <Stack gap={0} style={{ marginBottom: 'var(--mantine-spacing-lg)' }}>
      {!lowMargin &&
        (topElement ? topElement : <Space h={'var(--mantine-spacing-lg)'} />)}
      <Title order={2} style={style}>
        {title}
      </Title>
      <Space h={4} />
      <Text style={style}>{message}</Text>
    </Stack>
  );
};
